import React, { memo } from 'react';
import IconMC from '../../../components/IconMC';

const ContactMC = memo(({ contact }) => (
  <>
    <div className="tw-flex tw-items-center tw-justify-start tw-mb-2">
      <IconMC name="person-fill" size="lg" className="tw-mr-1 tw-text-[#3a71f1]" />
      {contact?.names?.formatted_name || '—'}
    </div>
    {Array.isArray(contact?.phones) && contact.phones.map((ph) => (
      <div key={ph?.phone} className="tw-flex tw-items-center tw-justify-start tw-mb-1">
        <IconMC name="phone-filled" size="sm" className="tw-mr-1 tw-text-[#3a71f1]" />
        {ph?.phone || '—'}
      </div>
    ))}
    {Array.isArray(contact?.emails) && contact.emails.map((em) => (
      <div key={em?.email} className="tw-flex tw-items-center tw-justify-start tw-mb-1">
        <IconMC name="email-symbol-outline" size="xl" className="tw-mr-1 tw-text-[#3a71f1] tw-font-semibold" />
        {em?.email || '—'}
      </div>
    ))}
    {Array.isArray(contact?.addresses) && contact.addresses.map((addrr, idx) => (
      <div key={addrr?.street || idx} className="tw-flex tw-items-center tw-justify-start tw-mb-1">
        <IconMC name="pin-fill" size="lg" className="tw-mr-1 tw-text-[#3a71f1] tw-font-semibold" />
        {addrr.street
          ? addrr.street
          : [addrr.city, addrr.state, addrr.country].filter(Boolean).join(', ') || '—'}
      </div>
    ))}
    {contact?.org?.company && (
      <div className="tw-flex tw-items-center tw-justify-start tw-mb-1">
        <IconMC size="lg" name="tabler-building-fill" className="tw-mr-1 tw-text-[#3a71f1] tw-font-semibold" />
        {contact.org.company}
      </div>
    )}
  </>
));

ContactMC.displayName = 'ContactMC';

export default ContactMC;
